import { createFileRoute } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout'
import GroupReceptionTop from '@/components/reports-route/groups/group-receptionTop'
import ReportGroupStatistical from '@/components/reports-route/groups/group-statistical'
import { useQuery } from '@tanstack/react-query'
import { reportSummaryGroups } from '@/api/report'
import { useReportGroupFilterStore } from '@/store/report-group-filter'
import { useShallow } from 'zustand/react/shallow'
import { useState } from 'react'
import GroupStatisticalDetail from '@/components/reports-route/groups/group-statistical-detail'
import { navigateGuard } from '@/utils/auth.js'
import { UserRole } from '@/constants/user.js'
import { addDays, format } from 'date-fns'
import { throwException } from '@/exceptions/throw-exception.js'
import QUERY_KEY from '@/constants/use-query-key.js'
export const Route = createFileRoute('/_auth/report/group')({
  beforeLoad: ({ location }) =>
    navigateGuard(location, [
      UserRole.ADMINISTRATOR,
      UserRole.SUPERVISOR,
      UserRole.TEAM_LEADER,
    ]),
  component: GroupReport,
})

function GroupReport() {
  const [showDetailGroup, setShowDetailGroup] = useState(null)
  const { rangeDate, groupAmount, fields, filterState } =
    useReportGroupFilterStore(
      useShallow((state) => ({
        rangeDate: state.rangeDate,
        groupAmount: state.groupAmount,
        fields: state.fields,
        filterState: state.filterState,
      })),
    )

  const fetchReportGroupSummary = async () => {
    const { page, pageSize } = filterState
    const payload = {
      fields: fields,
      from_date: format(rangeDate.from_date, 'yyyy-MM-dd'),
      to_date: format(addDays(rangeDate.to_date, 1), 'yyyy-MM-dd'),
      top_limit: Number(groupAmount),
      limit: pageSize,
      offset: (page - 1) * pageSize,
    }
    try {
      const res = await reportSummaryGroups({ data: payload })
      return res.data
    } catch (error) {
      throwException(error)
      return {}
    }
  }

  const {
    isLoading: isLoadingReportGroupSummary,
    data: queryDataReportGroupSummary,
  } = useQuery({
    queryKey: [
      QUERY_KEY.GET_SUMMARY_GROUP_REPORT,
      { params: { rangeDate, groupAmount, fields, filterState } },
    ],
    queryFn: fetchReportGroupSummary,
  })
  return (
    <Layout.Body>
      {showDetailGroup && (
        <GroupStatisticalDetail
          group={showDetailGroup}
          setShowDetailGroup={setShowDetailGroup}
        />
      )}
      {!showDetailGroup && (
        <>
          <GroupReceptionTop
            data={queryDataReportGroupSummary?.top}
            isLoading={isLoadingReportGroupSummary}
          />
          <ReportGroupStatistical
            setShowDetailGroup={setShowDetailGroup}
            data={queryDataReportGroupSummary?.list}
            isLoading={isLoadingReportGroupSummary}
            totalRecords={queryDataReportGroupSummary?.total}
          />
        </>
      )}
    </Layout.Body>
  )
}
